import React, { useEffect } from "react";

import { Button } from "semantic-ui-react";

import { useSync } from "data/hub/sync";

import { useBooleanState } from "hooks";
import Tooltip from "components/Tooltip";

import { useImportedStatus, useUpdateImportedStatusMutation } from "./hooks";
import { EditImportedSyncEntityModal } from "../EditImportedSyncEntityModal";
import { ImportedSyncEntityTable } from "../ImportedSyncEntityTable";

export function ImportedStatusTable() {
  const [isEditModalOpen, openEditModal, closeEditModal] = useBooleanState();

  const { syncInProgress, syncCompleted, runFullSync } = useSync();
  const { data, loading, error, reloadData } = useImportedStatus();
  const { update, loading: updating } = useUpdateImportedStatusMutation(() => {
    runFullSync();
    closeEditModal();
  });

  useEffect(() => {
    if (syncCompleted) reloadData();
  }, [syncCompleted, reloadData]);

  if (error) {
    return <div style={{ fontStyle: "italic" }}>{error}</div>;
  }

  return (
    <React.Fragment>
      <ImportedSyncEntityTable
        loading={loading}
        rows={data}
        columns={[
          { id: "contact-status", title: "Contact Status" },
          { id: "imported-contacts", title: "Imported Contacts" },
        ]}
      />

      {!loading && (
        <Tooltip
          title="You cannot edit Imported Status while a CRM sync is in progress"
          hidden={!syncInProgress}
        >
          <div style={{ display: "inline-block" }}>
            <Button primary disabled={syncInProgress} onClick={openEditModal}>
              Edit Imported Status
            </Button>
          </div>
        </Tooltip>
      )}
      {isEditModalOpen && (
        <EditImportedSyncEntityModal
          importedTypes={data}
          loading={updating}
          onClose={closeEditModal}
          onSubmit={update}
          title="Edit Imported Status"
          subtitle="Select status to sync with Hubly"
          columnName="Contact Status"
        />
      )}
    </React.Fragment>
  );
}

export default ImportedStatusTable;
